import { createContext } from 'react';

export const ContainerContext = createContext();
